export function countUnderAllocated(
  resources: Array<{ allocatedPercentage?: number }>,
  threshold = 80,
): number {
  return resources.filter((r) => (r.allocatedPercentage ?? 0) < threshold).length;
}